import { ReactElement } from 'react';

import { NumberCellFormatter } from '@evinced-private/ui-common';

export const renderNumberCellFormatter = (value: number): ReactElement => {
	return <NumberCellFormatter value={value} />;
};
